export default import.meta.ROLLUP_FILE_URL_s1ra5D6$EpvlJSqnFAJIXg